import { lazy, Suspense } from 'react';
import LazyLoading from '../../../components/LazyLoading';

export const LazyOdv = lazy(() =>
  import(/* webpackChunkName: 'Sales opening list' */ './index'),
);

export default function Odv(props) {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyOdv {...props} />
    </Suspense>
  );
}
